export default __webpack_public_path__ + "static/media/cnn_en_jing_b3.c46d9452.mp3";